class @ClipboardButton

  @setup: ->

    $copy_inputs  = $("input.copy-to-clipboard, textarea.copy-to-clipboard")
    $copy_anchors = $("a.copy-to-clipboard")

    if isFlashEnabled()
      ZeroClipboard.setDefaults
        moviePath: Routes.root_path() + "zero-clipboard/zero-clipboard.swf"
      clip = new ZeroClipboard($copy_anchors)

      clip.on "complete", ->
        $anchor = $(this)
        $copy_anchors.text(t "copy_and_paste.offer_copy")
        $anchor.text(t "copy_and_paste.link_copied")
    else
      $copy_anchors.hide()

    $copy_inputs
      .on "focus", ->
        $(this).select()
        return true
      .on "mouseup", ->
        return false
